import React, { memo, useMemo, useRef, useState } from 'react';
import { ValuationRegisterNoForm } from '../../components/valuation/register-no';
import { ValuationVinForm } from '../../components/valuation/vin';
import { useNavigate, useParams } from 'react-router-dom';
import { ValuationCustomForm } from '../../components/valuation/custom';
import { Header } from '../../components/layout/header';
import { Button, message } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { ValuationApi } from '../../apis';
import { ValuationResponseTable } from '../../components/valuation/valuation-response-table';
import { PageLoader } from '../../components/home/page-loader';
import { InfoCalculator } from '../../components/home/info';
import { uploadFirstFour } from '../../utils';
import { useSelector } from 'react-redux';
import { AuthState } from '../../store/reducer/auth';
import { NotFound } from '../../components/home/not-found';
import { AdditionalForm } from '../../components/valuation/additional';
import { NavigationRoutes } from '../../navigation/type';

type Props = {
  type?: 'PLATE_NUMBER' | 'VIN' | 'CUSTOM';
};

const ValuationScreen = memo(() => {
  const { type } = useParams() as Props;
  const [percent, setPercent] = useState(0);
  const [images, setImages] = useState<string[]>([]);
  const [messageaApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const { accessToken } = useSelector((state: { auth: AuthState }) => state?.auth);
  const navigate = useNavigate();

  const [action, setAction] = useState<{
    loading: boolean;
    payload: any;
    found?: 'ADDITIONAL_DATA' | 'IS_ADDITIONAL_DATA' | boolean; // undefined, null, boolean, string
  }>({
    loading: false,
    payload: undefined,
    found: undefined,
  });

  const printRef = useRef<HTMLDivElement>(null);

  const print = async () => {
    setLoading(true);
    if (images.length === 4) {
      if (action?.payload?.id) {
        try {
          const imageUrls = await uploadFirstFour(images, accessToken!);

          await ValuationApi.finalize({
            id: action?.payload?.id,
            percentOdo: action.payload.percentOdo,
            percentBranchHead: action.payload.percentBranchHead,
            imageUrls: imageUrls,
            hasVat: action.payload?.hasVat
          });

          // await delay(300);

          // const res = await ValuationApi.pdf(action?.payload?.id);

          // downloadPDF(res.url);
          // setLoading(false);

          navigate(NavigationRoutes.Valuation_ListScreen);
        } catch {
          setLoading(false);
          messageaApi.error('PDF-ыг татахад  алдаа гарлаа');
          //
        }
      }
      messageaApi.success('PDF-ыг амжилттай̆ татлаа');
    } else {
      setLoading(false);
      messageaApi.error('Та машины 4-н зургаа оруулна уу');
      return;
    }
  };

  const render = useMemo(() => {
    switch (type) {
      case 'CUSTOM':
        return <ValuationCustomForm setAction={setAction} />;
      case 'PLATE_NUMBER':
        return <ValuationRegisterNoForm setAction={setAction} />;
      case 'VIN':
        return <ValuationVinForm setAction={setAction} />;
    }
  }, [type]);

  return (
    <>
      {contextHolder}
      <div className="flex-col bg-white rounded-[8px] p-5">
        <Header
          title="Үнэлгээ хийх"
          isGoBack={true}
          options={
            action?.payload?.id && (
              <Button onClick={print} loading={loading}>
                <FilePdfOutlined />
              </Button>
            )
          }
        />
        <div className="flex flex-row w-full">
          <div>{render}</div>
          <div className="w-[40px]" />

          {action.loading === true && !action.payload && <PageLoader />}
          {action.loading === false && action.found === 'ADDITIONAL_DATA' && (
            <AdditionalForm action={action} />
          )}
          {action.loading === false &&
            action?.payload?.isComparable === false &&
            action.found === 'IS_ADDITIONAL_DATA' && <NotFound setAction={setAction} />}
          {action.loading === false && action?.payload?.isComparable === true && action.payload && (
            <>
              <div style={{ display: 'none' }}>
                <InfoCalculator printRef={printRef} action={action} percent={percent} />
              </div>
              <ValuationResponseTable
                setImage={(e) => {
                  setImages(e);
                }}
                action={action}
                setPercent={setPercent}
                setAction={setAction}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
});

ValuationScreen.displayName = 'ValuationScreen';

export { ValuationScreen };
